import { createRoot } from 'react-dom/client';
export function createElement(jsx) {
    const element = document.createElement('div');
    element.style.padding = '1em';
    const root = createRoot(element);
    root.render(jsx);
    return element;
}
//# sourceMappingURL=dom.js.map